import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { scholarshipTypes } from '../../../../../utils/consts/orders/scholarships';
import { StepProps } from './AddEditScholarship';
import { NumberInput } from '../../../../../components/inputs/NumberInput';

export const ScholarshipForm = ({ touched, errors, values, setFieldValue }: StepProps) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Scholarship Details" />
        </Col>
        <Col
          xs={12}
          lg={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="scholarship_type"
          >
            <FormLabel required>Scholarship Type</FormLabel>
            <Field
              name="scholarship_type"
              as={Form.Select}
              isInvalid={touched.scholarship_type && !!errors.scholarship_type}
              aria-required
            >
              <option>Select</option>
              {Object.entries(scholarshipTypes).map((type, idx) => (
                <option
                  key={idx}
                  value={type[0]}
                >
                  {type[1]}
                </option>
              ))}
            </Field>
            <ErrorMessage name="scholarship_type">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>

          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="percent_discount"
          >
            <FormLabel required>Percent Discount</FormLabel>
            <Field
              name="percent_discount"
              min={1}
              as={NumberInput}
              isInvalid={touched.percent_discount && !!errors.percent_discount}
              aria-required
            />
            <ErrorMessage name="percent_discount">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};
